module.exports = {
  detailOfTheBill: '单据明细', // 单据明细
  EggStockInDetails: '种蛋入库明细', // 种蛋入库明细
  purchaseOrder: '采购订单', // 采购订单
  purchaseOrderDetails: '采购订单明细', // 采购订单明细
  openOrders: '未清订单', // 未清订单
  orderDetails: '订单明细', // 订单明细
  outgoingDetails: '出库明细', // 出库明细
  inboundDetails: '入库明细', // 入库明细
  transferDetails: '调拨明细', // 调拨明细
  eggCollectionDetails: '收蛋明细', // 收蛋明细
  regular: '常规', // 常规
  price: '身价', // 身价
  entryDetails: '入舍明细', // 入舍明细
  feedingDetails: '饲喂明细', // 饲喂明细
  immunizationAndMedicationDetails: '免疫及用药明细', // 免疫及用药明细
  mortality: '死淘', // 死淘
  eggProduction: '蛋品入库', // 蛋品入库
  cull: '出栏', // 出栏
  selectCulling: '选淘登记', // 选淘登记
  selectCullingDetails: '选淘登记明细', // 选淘登记明细
  registrationDetailsOfSlaughterhouse: '出栏登记明细', // 出栏登记明细
  transferOutDetails: '转出明细', // 转出明细
  transferInDetails: '转入明细', // 转入明细
  breakdownOfHerd: '分群明细', // 分群明细
  testCollectionDetails: '试验领用明细', // 试验领用明细
  weightBreakdown: '体重明细', // 体重明细
  weeklyPlanDetail: '周计划明细', // 周计划明细
  deadAmoyDetail: '死淘明细', // 死淘明细
  egg: '照蛋', // 照蛋
  dropTray: '落盘', // 落盘
  hatching: '出雏', // 出雏
  feedingStandardDetails: '饲喂标准明细', // 饲喂标准明细
  vaccinationStandardDetails: '免疫标准明细', // 免疫标准明细
  antibodyStandardDetails: '抗体标准明细', // 抗体标准明细
  environmentalStandards: '环境标准', // 环境标准
  rearingPeriod: '饲养期', // 饲养期
  periodCode: '期间代码',//期间代码
  feedingStandards: '饲喂标准', // 饲喂标准
  immunizationStandards: '免疫标准', // 免疫标准
  medicationStandard: '用药标准', // 用药标准
  incubationDetails: '上孵明细', // 上孵明细
  recheckDetails: '复检明细', // 复检明细
  detailsOfEggsAndFallingPlates: '照蛋及落盘明细', // 照蛋及落盘明细
  hatchingDetails: '出雏明细', // 出雏明细
  lowConsumptionDetails: '低耗明细',//低耗明细
  breedingStandard: '养殖标准',//养殖标准
  securityDeposit: '保证金',//保证金
  materialSettlementPrice: '物资结算价格',//物资结算价格
  fees: '费用',//费用
  subsidy: '补贴',//补贴
  recoveryPrice: '回收价格',//回收价格
  recoverySettlement: '回收结算',//回收结算
  remarks: '备注',//备注
  priceList: '价格清单',//价格清单
  feedDetail: '饲料明细',//饲料明细
  detailsOfTheMove: '动保明细',//动保明细
  materialDetails: '物料明细',//物料明细
  contractPriceListDetails: '合同价格清单详情',//合同价格清单详情
  symptoms: '症状',//症状
  visceralAnatomy: '脏器解剖',//脏器解剖
  treatmentOptions: '治疗方案',//治疗方案
  inspectionItem: '巡检项',//巡检项
  consumptionInformation: '耗用信息',//耗用信息
  subsidyItem: '补贴项',//补贴项
  expenseItem: '费用项',//费用项
  penalty: '惩罚项',//惩罚项
  settlement: '结算',//结算
  consumptionSummary: '耗用汇总',//耗用汇总
  columnSummary: '出栏汇总',//出栏汇总
  marginRecord: '保证金记录',//保证金记录
  materialConversionDetails: '物料转换明细',//物料转换明细
  eggStorage: '蛋品入库(换羽)',//蛋品入库(换羽)
  receipt: '领用',//领用
  requisitionStatistics: '领用统计'//领用统计
}